import { normalizeDashboards } from '../../../../utils'

import {
    OtherUsersDashboardsDocument as otherUsersDashboardQuery,
    type OtherUsersDashboardsQuery,
    type QueryResolvers,
    UserDashboardsDocument as ownDashboardQuery,
    type UserDashboardsQuery,
} from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'

export const dashboardsResolver: QueryResolvers<ApolloResolverContext>['dashboards'] = async (
    _root,
    { userId },
    { client },
) => {
    console.debug('io-dashboards dashboardsResolver deprecated, use getAllDashboards')

    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    if (userId) {
        const { data } =
            (await client.query<OtherUsersDashboardsQuery>({
                query: otherUsersDashboardQuery,
                variables: { userId },
                fetchPolicy: 'network-only',
            })) || {}

        const dashboards = normalizeDashboards(data?.administrator?.user?.dashboards)

        return dashboards.map((d) => JSON.stringify(d))
    }

    const { data } =
        (await client.query<UserDashboardsQuery>({
            query: ownDashboardQuery,
            fetchPolicy: 'network-only',
        })) || {}

    const dashboards = normalizeDashboards(data?.user?.dashboards)

    return dashboards.map((d) => JSON.stringify(d))
}
